export const MITRE_TACTIC_URL = 'https://attack.mitre.org/tactics/'
export const MITRE_TECHNIQUE_URL = 'https://attack.mitre.org/techniques/'

export const AttackChainCommandEnum = {
  NONE: 'NONE',
  INITIAL_ACCESS: 'initialAccess',
  EXECUTION: 'execution',
  PERSISTENCE: 'persistence',
  PRIVILEGE_ESCALATION: 'privilegeEscalation',
  DEFENSE_EVASION: 'defenseEvasion',
  CREDENTIAL_ACCESS: 'credentialAccess',
  DISCOVERY: 'discovery',
  LATERAL_MOVEMENT: 'lateralMovement',
  COLLECTION: 'collection',
  EXFILTRATION: 'exfiltration',
  COMMAND_AND_CONTROL: 'commandAndControl',
  IMPACT: 'impact',
  properties: {
    initialAccess: {
      step: 1,
      title: 'Initial Access',
      command: 'INITIAL_ACCESS'
    },
    execution: {
      step: 2,
      title: 'Execution',
      command: 'EXECUTION'
    },
    persistence: {
      step: 3,
      title: 'Persistence',
      command: 'PERSISTENCE'
    },
    privilegeEscalation: {
      step: 4,
      title: 'Privilege Escalation',
      command: 'PRIVILEGE_ESCALATION'
    },
    defenseEvasion: {
      step: 5,
      title: 'Defense Evasion',
      command: 'DEFENSE_EVASION'
    },
    credentialAccess: {
      step: 6,
      title: 'Credential Access',
      command: 'CREDENTIAL_ACCESS'
    },
    discovery: {
      step: 7,
      title: 'Discovery',
      command: 'DISCOVERY'
    },
    lateralMovement: {
      step: 8,
      title: 'Lateral Movement',
      command: 'LATERAL_MOVEMENT'
    },
    collection: {
      step: 9,
      title: 'Collection',
      command: 'COLLECTION'
    },
    exfiltration: {
      step: 10,
      title: 'Exfiltration',
      command: 'EXFILTRATION'
    },
    commandAndControl: {
      step: 11,
      title: 'Command And Control',
      command: 'COMMAND_AND_CONTROL'
    },
    impact: {
      step: 12,
      title: 'Impact',
      command: 'IMPACT'
    }
  }
}

export const AttackChainCommandTactics = [
  {
    step: 1,
    title: 'Initial Access',
    command: 'INITIAL_ACCESS'
  },
  {
    step: 2,
    title: 'Execution',
    command: 'EXECUTION'
  },
  {
    step: 3,
    title: 'Persistence',
    command: 'PERSISTENCE'
  },
  {
    step: 4,
    title: 'Privilege Escalation',
    command: 'PRIVILEGE_ESCALATION'
  },
  {
    step: 5,
    title: 'Defense Evasion',
    command: 'DEFENSE_EVASION'
  },
  {
    step: 6,
    title: 'Credential Access',
    command: 'CREDENTIAL_ACCESS'
  },
  {
    step: 7,
    title: 'Discovery',
    command: 'DISCOVERY'
  },
  {
    step: 8,
    title: 'Lateral Movement',
    command: 'LATERAL_MOVEMENT'
  },
  {
    step: 9,
    title: 'Collection',
    command: 'COLLECTION'
  },
  {
    step: 10,
    title: 'Exfiltration',
    command: 'EXFILTRATION'
  },
  {
    step: 11,
    title: 'Command And Control',
    command: 'COMMAND_AND_CONTROL'
  },
  {
    step: 12,
    title: 'Impact',
    command: 'IMPACT'
  }
]



// WEBPACK FOOTER //
// ./src/constants/attack-chain.constants.js